import { ElemasonAuthStep } from '@tectonic/types';
import { Button } from '../../../components';
import { useAuthStore } from '../../../store';

import type { FC } from 'react';
import type { AuthStepWidgetProps } from './AuthStep.types';

const AuthStepWidget: FC<AuthStepWidgetProps> = ({ widget }) => {
  const widgetConfig = widget.config ?? {};
  const wData = widget.data!;

  const setStep = useAuthStore((state) => state.setStep);

  const onClick = () => {
    if (wData.step === ElemasonAuthStep.EXIT) {
      globalThis.location.reload();
      return;
    }
    setStep(wData.step);
  };

  return (
    <Button
      config={widgetConfig.cta?.button}
      data={wData.cta.button}
      onClick={onClick}
    />
  );
};

AuthStepWidget.displayName = 'AuthStepWidget';

export { AuthStepWidget };
